import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
const Header = ({ auth }) => {
  return (
    <div>
      <div className="checkout-header">
        <Link to="/">
          <img className="checkout-header-logo" src="/assets/logo.png" alt="" />
        </Link>
      </div>
      <div className="checkout-logged-in-container">
        {auth.isAuthenticated === "null" && (
          <div className="checkout-logged-in">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <p className="checkout-logged-in-text">¿Ya estás registrado?</p>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <Link
                  to="/login"
                  type="button"
                  className="btn btn-outline-dark"
                >
                  <p className="font-weight-bold">Ingresar</p>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = ({ auth }) => ({
  auth
});
export default connect(mapStateToProps)(Header);
